import { render, staticRenderFns } from "./TiposItemRendimiento.vue?vue&type=template&id=1893a014&"
import script from "./TiposItemRendimiento.vue?vue&type=script&lang=js&"
export * from "./TiposItemRendimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports